import { StoryBoardTracks } from 'services/storyboard.service';
import { isNull, selectClipData } from 'components/app/_helpers/_app.helper';
import { getLinkData } from 'components/app/editor/_mediator/editor-clips/editor-clips-linking.helper';
import { EMPTY_CELL } from 'components/app/editor/_mediator/editor.slice';

/* external iface */
import { useAppSelector } from 'store/store-hooks';

export const useSbDndSelect = (clipId: CellClip, cell: Index, track: StoryBoardTracks) => {
  const sbPosition = useAppSelector((state) => state.editor__controls.sbPosition);
  const linkedClips = useAppSelector((state) => state.editor.linkedClips);
  const activeClip = useAppSelector((state) => state.editor.activeClip);
  const clipsMap = useAppSelector((state) => state.editor.clipsMap);
  const storyBoard = useAppSelector((state) => state.editor.storyBoard);

  const getLinkOffset = (clipId: ClipId, isLeftMost: boolean) => {
    if (!clipsMap) return 0;
    const clipData = selectClipData(clipId, clipsMap);
    const linkData = getLinkData(clipData, linkedClips);
    if (isNull(linkData)) return 0;
    if (isLeftMost ? linkData.isFirstInGroup : linkData.isLastInGroup) return 0;
    return isLeftMost ? linkData.index : linkData.group.length - (linkData.index + 1);
  };

  return () => {
    if (!activeClip) return;
    if (clipId === EMPTY_CELL) return;
    if (activeClip === clipId) return;
    if (sbPosition.track !== track) return;
    const isLeftDirection = cell < sbPosition.cell;
    const offsetStart = getLinkOffset(activeClip, !isLeftDirection);
    const offsetEnd = getLinkOffset(clipId!, isLeftDirection);
    const clips = isLeftDirection
      ? storyBoard[track].slice(cell - offsetEnd, sbPosition.cell + offsetStart + 1)
      : storyBoard[track].slice(sbPosition.cell - offsetStart, cell + offsetEnd + 1);
    return clips as ClipId[];
  };
};
